import { render, staticRenderFns } from "./group-info-preview-popup.html?vue&type=template&id=c97a595e&scoped=true&external"
import script from "./group-info-preview-popup.js?vue&type=script&lang=js&external"
export * from "./group-info-preview-popup.js?vue&type=script&lang=js&external"
import style0 from "./group-info-preview-popup.scss?vue&type=style&index=0&id=c97a595e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97a595e",
  null
  
)

export default component.exports